import { colors } from '@alixpartners/ui-components';

export const CHART_COLORS = {
	GREEN: colors.chartMediumGreen,
	RED: colors.red1,
	GREY: colors.chartMediumGrey,
	TEAL: colors.chartBrightTeal,
};

export const getMonthCategories = count => {
	const number = count || 12;

	return [...new Array(number)].map((_, index) => `P${index + 1}`);
};

export const LEGEND = {
	RED: 'Revised budget overrun',
	GREEN: 'Savings target achieved',
};
